/*
 * pdp-gallery-autoplay.js
 * -------------------------------------------------------------------------
 * Auto-advances the product media gallery like a slider by cycling the
 * thumbnails (Dawn's <media-gallery> switches the main image on thumbnail
 * click). Behaviour requested:
 *   - images move automatically (every ADVANCE_MS)
 *   - pause the moment the user hovers or interacts (swipe / click / key)
 *   - after IDLE_MS (10s) of no hover and no interaction, resume
 * Only real user gestures pause it — our own programmatic .click() fires a
 * 'click' but NOT pointerdown/touchstart, so the loop never pauses itself.
 * Respects prefers-reduced-motion.
 *
 * Also freezes while the user is typing in a search field: on mobile the
 * search modal opens OVER the product page, and each auto-advance switches
 * the main image (a reflow/scroll) that yanks the cursor out of the search
 * box. We halt all advancing on search focus and resume once search blurs.
 * -------------------------------------------------------------------------
 */
(function () {
  var ADVANCE_MS = 3000;
  var IDLE_MS = 10000;

  // Global "user is searching" latch, shared across every gallery on the page.
  var searchActive = false;
  function isSearchField(el) {
    return !!(el && el.matches && el.matches(
      'input[type="search"], .search__input, [data-predictive-search] input, input[name="q"]'
    ));
  }
  document.addEventListener('focusin', function (e) {
    if (isSearchField(e.target)) searchActive = true;
  });
  document.addEventListener('focusout', function (e) {
    if (isSearchField(e.target)) searchActive = false;
  });

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function (gallery) {
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail'));
      if (thumbs.length < 2) return;                 // nothing to cycle

      var timer = null;
      var idleAt = Date.now();
      var hovering = false;

      function currentIndex() {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('aria-current') === 'true') return i;
        }
        return 0;
      }
      function advance() {
        var next = (currentIndex() + 1) % thumbs.length;
        thumbs[next].click();                        // Dawn switches the main image
      }
      function play() {
        if (timer) return;
        timer = setInterval(function () { if (!hovering && !searchActive) advance(); }, ADVANCE_MS);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function bumpActivity() {                       // real user gesture
        idleAt = Date.now();
        stop();
      }

      // Hover pauses; leaving starts the idle countdown.
      gallery.addEventListener('mouseenter', function () { hovering = true; stop(); });
      gallery.addEventListener('mouseleave', function () { hovering = false; idleAt = Date.now(); });

      // Only genuine input pauses (NOT synthetic click from advance()).
      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
        gallery.addEventListener(ev, bumpActivity, { passive: true });
      });

      // Resume watcher: idle for IDLE_MS, not hovering, not already playing.
      setInterval(function () {
        if (!timer && !hovering && (Date.now() - idleAt) >= IDLE_MS) play();
      }, 1000);

      idleAt = Date.now();
      play();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
